<template>
	<div class="px-2 py-4 wrapper flex flex-col bg-white border-b-2 border-solid text-left">
		<h1 class="font-normal leading-none mb-2" :class="titleSize" style="white-space: pre-line">
			{{ this.title }}
			<font-awesome-icon :icon="['fas', icon]" class="ml-8 text-green-500" v-if="icon" />
		</h1>
		<slot>
			<div class="h-6"></div>
		</slot>
	</div>
</template>

<script>
export default {
	name: 'Header',
	props: {
		title: {
			type: String,
			required: true,
		},
		titleSize: {
			required: false,
			default: 'text-3xl'
		},
		icon: {},
	},
};
</script>

<style scoped></style>
